/* eslint-disable */
import { LensTwoTone } from "@material-ui/icons";
import { cloneDeep, orderBy } from "lodash";
import { uniq } from "../../../../shared";

const castToT = (obj: unknown) => obj as Record<string, string>; // TODO: Hot fix
export type Hierarchy<T> = {
  id: string;
  parent: string | undefined;
  children: Hierarchy<T>[];
  item: T;
  parentHierarchy: Hierarchy<T> | undefined;
  key: string;
  parentKey: string | undefined;
};

class Log {
  private static _stack: Log[] = [];

  constructor(enabled: boolean = true) {
    if (enabled && window.location.host.includes('localhost')) {
      Log._stack.push(this);
    }
  }

  first(message: string | any[]) {
    if (this === Log._stack[0]) {
      this.log(message);
    }
  }

  all(message: string | any[]) {
    this.log(message);
  }

  last(message: string | any[]) {
    if (this === Log._stack[Log._stack.length - 1]) {
      this.log(message);
    }
  }

  logif(flag: boolean, message: string | any[]) {
    if (flag) {
      this.log(message);
    }
  }

  private log(message: string | any[]) {
    if (Log._stack.includes(this)) {
      console.log(message);
    }
  }
}

export function hierarchies<T>(items: T[], idKey: string, parentKey: string, outputKey?: string, outputparentKey?: string): Hierarchy<T>[] {
  outputKey = outputKey || idKey;
  outputparentKey = outputparentKey || parentKey;
  const getUnreg = (key: string) => items && items[0] && Object.keys(items[0]).find(k => k.toLowerCase() === key.toLowerCase()) || key;

  const [keyUnreg, parentKeyUnreg, keyOutUnreg, parentOutKeyUnreg] = [idKey, parentKey, outputKey, outputparentKey].map(k => getUnreg(k));
  const itemsKeys = items.map(x =>  castToT(x)[keyUnreg] || castToT(x)[keyOutUnreg]);

  const result: Hierarchy<T>[] = [];
  if (keyUnreg && parentKeyUnreg) {
    if (items.every((x) => castToT(x)[keyUnreg] || castToT(x)[keyOutUnreg])) {
      const poolValues = (items.map((x) => [`${castToT(x)[keyUnreg] || castToT(x)[keyOutUnreg]}`, x]) as any);
      const pool = new Map<string, T>(poolValues);
      // const log = new Log(Boolean(pool.size) && items.some(x => Boolean(castToT(x)[parentKeyUnreg])));
      let max = 3000;
      while (pool.size > 0 && max > 0) {
        // TODO: Утекаем
        max--;
        // if (max < 1) {
        //   log.first(['Утечка памяти', items, pool, result]);
        // }
        for (const item of items) {
          const pushHierarchy = (parentHierarchy?: Hierarchy<T>) => {
            const pKey = castToT(item)[parentKeyUnreg] == null ? undefined : castToT(item)[parentKeyUnreg];
            const pOutKey = castToT(item)[parentOutKeyUnreg] == null ? undefined : castToT(item)[parentOutKeyUnreg];
            const pKeyResult = pOutKey || pKey;
            if (pool.has(`${castToT(item)[keyUnreg]}`)) {
              ((parentHierarchy && parentHierarchy.children) || result).push({
                key: `${castToT(item)[keyUnreg] || castToT(item)[keyOutUnreg]}`,
                parentKey: (pKey || pOutKey) !== undefined ? `${(pKey || pOutKey)}` : undefined,
                id: `${castToT(item)[keyOutUnreg] || castToT(item)[keyUnreg]}`,
                parent: pKeyResult !== undefined ? `${pKeyResult}` : undefined,
                children: [],
                parentHierarchy,
                item: item as T,
              });
              pool.delete(`${castToT(item)[keyUnreg] || castToT(item)[keyOutUnreg]}`);
            }
          };
          // log.first([`item[${parentKeyUnreg}] = ${castToT(item)[parentKeyUnreg]} | item[${parentOutKeyUnreg}] = ${castToT(item)[parentOutKeyUnreg]}`, item]);
          if (castToT(item)[parentKeyUnreg] === undefined || castToT(item)[parentOutKeyUnreg] === null) {
            pushHierarchy();
          } else {
            if (!items.some((x) => `${castToT(x)[keyUnreg]}` === `${castToT(item)[parentKeyUnreg]}`)) {
              pushHierarchy();
            } else {
              let parent = result.find((x) => x.key === `${castToT(item)[parentKeyUnreg]}`);
              if (!parent) {
                hierarchyIterator: for (const hierarchy of result.filter((x) => Boolean(x.children.length))) {
                  parent = hierarchy.children.find((x) => x.key === `${castToT(item)[parentKeyUnreg]}`);
                  if (parent) break;

                  let contexts: (Hierarchy<T>[] | null)[] = [
                    hierarchy.children.filter((x) => Boolean(x.children.length)),
                  ];
                  let clearContext = contexts.filter((x) => x && x.length);
                  let iteration = 0;
                  while (clearContext.length && iteration < 300) {
                    iteration++;
                    const context = clearContext[clearContext.length - 1];
                    if (context) {
                      for (const child of context) {
                        parent = child.children.find((x) => x.key === `${castToT(item)[parentKeyUnreg]}`);
                        if (parent) break hierarchyIterator;
                        const newContext = child.children.filter((x) => Boolean(x.children.length));
                        if (child === context[context.length - 1]) {
                          contexts[contexts.indexOf(context)] = null;
                        }
                        if (newContext.length) contexts.push(newContext);
                      }
                    }
                    clearContext = contexts.filter((x) => x && x.length);
                  }

                  let contextChildren = hierarchy.children.filter((x) => Boolean(x.children.length));
                  for (const child of contextChildren) {
                    parent = child.children.find((x) => x.key === `${castToT(item)[parentKeyUnreg]}`);
                    if (parent) break hierarchyIterator;

                    let contextChildren2 = child.children.filter((x) => Boolean(x.children.length));
                    for (const child2 of contextChildren2) {
                      parent = child2.children.find((x) => x.key === `${castToT(item)[parentKeyUnreg]}`);
                      if (parent) break hierarchyIterator;
                    }
                  }
                }
              }

              if (parent) {
                pushHierarchy(parent);
                parent.children = orderBy(parent.children, childHierarchy => {
                  const sortedIndex =  itemsKeys.indexOf(childHierarchy.key);
                  return sortedIndex;
                });
              }
            }
          }
        }
      }
    } else {
      new Error(`Not every item has ${idKey}`);
    }
  } else {
    new Error(`Not set idKey or parentKey`);
  }
  return result;
}

export function addHierarchy<T>(hierarchies: Hierarchy<T>[], hierarchy: Hierarchy<T>): Hierarchy<T>[] {
  const tree: Hierarchy<T>[] = [hierarchy];
  let cursor = hierarchy;
  while (cursor.parentHierarchy) {
    cursor = cloneDeep(cursor.parentHierarchy);
    cursor.children = [];
    tree.push(cursor);
  }

  const reversedTree = tree.reverse();
  let cursorTree = hierarchies;
  for (const treeItem of reversedTree) {
    let nextCursor = cursorTree.find((x) => x.id === treeItem?.id)?.children;
    if (!nextCursor) {
      cursorTree.push(treeItem);
      nextCursor = treeItem.children;
    }
    cursorTree = nextCursor;
  }
  return hierarchies;
}

export function removeHierarchy<T>(hierarchies: Hierarchy<T>[], hierarchy: Hierarchy<T>): Hierarchy<T>[] {
  let cursor: Hierarchy<T> | undefined = hierarchiesFindChild(hierarchies, hierarchy.id);
  while (cursor) {
    const tree = cursor.parentHierarchy?.children || hierarchies;
    const index = tree.findIndex((x) => x.id === cursor?.id);
    if (~index) {
      tree.splice(index, 1);
    }
    if (tree.length === 0) {
      cursor = cursor.parentHierarchy;
    } else {
      cursor = undefined;
    }
  }
  return hierarchies;
}

export function hierarchyFindChild<T>(hierarchy: Hierarchy<T>, childId: string): Hierarchy<T> | undefined {
  if (hierarchy.id === childId) return hierarchy;
  let contexts: (Hierarchy<T>[] | null)[] = [hierarchy.children];
  let clearContext = contexts.filter((x) => x && x.length);
  let iteration = 0;
  while (clearContext.length && iteration < 300) {
    iteration++;
    const context = clearContext[clearContext.length - 1];
    if (context) {
      for (const child of context) {
        const findedResult = child.id === childId ? child : child.children.find((x) => x.id === childId);
        if (findedResult) {
          return findedResult;
        }

        const newContext = child.children;
        if (child === context[context.length - 1]) {
          contexts[contexts.indexOf(context)] = null;
        }
        if (newContext.length) contexts.push(newContext);
      }
    }
    clearContext = contexts.filter((x) => x && x.length);
  }
  return undefined;
}

export function hierarchiesFindChild<T>(hierarchies: Hierarchy<T>[], childId: string): Hierarchy<T> | undefined {
  for (const hierarchy of hierarchies) {
    const child = hierarchyFindChild(hierarchy, childId);
    if (child) {
      return child;
    }
  }

  return undefined;
}

export function hierarchyAllByChildId<T>(hierarchies: Hierarchy<T>[], childId: string): Hierarchy<T>[] {
  let result: Hierarchy<T>[] = [];
  let candidates: Hierarchy<T>[] | null = hierarchies;
  while ((candidates || []).length > 0) {
    for (let i = 0; i < (candidates || []).length; i++) {
      const candidate = candidates![i];
      if (candidate.id === childId) {
        candidates = null;
        break;
      }
      const allChildrenIds = hierarchiesGetAllIds([candidate], false);
      if (candidate && allChildrenIds.includes(childId)) {
        result.push(candidate);
        candidates = candidate.children;
        break;
      }
      if (i === candidates!.length - 1) {
        candidates = null;
      }
    }
  }
  return result;
}

export function hierarchiesGetAllIds<T>(hierarchies: Hierarchy<T>[], ignoreParents: boolean = true): string[] {
  const result: string[] = [];
  for (const hierarchy of hierarchies.filter(Boolean)) {
    if (!hierarchy.children?.length) {
      result.push(hierarchy.id);
    }
    let contexts: (Hierarchy<T>[] | null)[] = [hierarchy.children];
    let clearContexts = contexts.filter((x) => x && x.length);
    while (clearContexts.length) {
      const context = clearContexts[clearContexts.length - 1];
      if (context) {
        for (const child of context) {
          if (!ignoreParents || !child.children?.length) {
            result.push(child.id);
          }
          const newContext = child.children;
          if (child === context[context.length - 1]) {
            contexts[contexts.indexOf(context)] = null;
          }
          if (newContext.length) contexts.push(newContext);
        }
      }
      clearContexts = contexts.filter((x) => x && x.length);
    }
  }
  return result;
}

export function hierarchiesFlat<T>(hierarchies: Hierarchy<T>[]): Hierarchy<T>[] {
  let result: Hierarchy<T>[] = [...hierarchies.filter(Boolean)];
  while (result.some(h => h.children?.some(c => !result.includes(c)))) {
    result = uniq([ ...result, ...result.flatMap(e => e.children)].filter(Boolean));
  }
  return result;
}